export default __webpack_public_path__ + "static/media/gif-remove-oculos.9058c621.gif";